export const colorMap: Record<string, string> = {
  unknown: 'bg-primary',
  planned: 'bg-success text-black',
  unplanned: 'bg-very-negative',
  active: 'bg-warning text-black',
  inactive: 'bg-body text-success',
  cancelled: 'bg-body',
};

export const toggleMap: Record<string, string> = {
  unknown: 'outline-info',
  planned: 'outline-success',
  unplanned: 'outline-danger',
  active: 'outline-warning',
  inactive: 'outline-success',
  cancelled: 'outline-danger',
};
